import { Component, OnDestroy, OnInit } from '@angular/core';
import { NgbDropdownModule, NgbModal, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { ApiUrls } from '../apiurls';
import { HttpClient } from '@angular/common/http';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import {
  LOCAL_STORAGE_KEYS,
  LocalStorageItemsService,
} from '../../services/local-storage-items.service';
import { HospitalityService } from '../../services/hospitality.service';
import { HospitalityUnitComponent } from '../hospitality-unit/hospitality-unit.component';
import { CommonModule } from '@angular/common';
import { SocketService } from '../../services/socket.service';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../environments/environment';
import { NavBarComponent } from '../../pages/nav-bar/nav-bar.component';
import { Subject, filter, takeUntil } from 'rxjs';
import { SettingsTabsComponent } from '../settings-tabs/settings-tabs.component';
import { MastersTabsComponent } from '../masters-tabs/masters-tabs.component';
import { WorkflowsTabsComponent } from '../workflows-tabs/workflows-tabs.component';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [NgbDropdownModule, RouterModule, HospitalityUnitComponent, CommonModule, SettingsTabsComponent, MastersTabsComponent, WorkflowsTabsComponent, NgbTooltipModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent implements OnInit, OnDestroy {
  userDetails: any = {};
  activeTab: string = 'home';
  activeSettingsTab: string = 'general';
  activemasterTab: string = 'employees';

  isHeaderExpanded: boolean = true;

  get isSettingsRoute(): boolean { return this.activeTab === 'settings'; }
  get isMastersRoute(): boolean { return this.activeTab === 'masters'; }
  get isWorkflowsRoute(): boolean { return this.activeTab === 'workflows'; }
  get canShowSettingsTab(): boolean {
    const designation = String(this.userDetails?.designation || '').trim().toLowerCase();
    return designation === 'caratred supervisor' || designation === 'admin';
  }

  toggleHeader(): void {
    this.isHeaderExpanded = !this.isHeaderExpanded;
    this.hospitalityService.setHeaderExpanded(this.isHeaderExpanded);
  }

  private destroy$ = new Subject<void>();

  constructor(
    private http: HttpClient,
    private router: Router,
    private hospitalityService: HospitalityService,
    private localStorageService: LocalStorageItemsService,
    private socketService: SocketService,
    private toastr: ToastrService,
    private modalService: NgbModal
  ) {}

  ngOnInit(): void {
    this.localStorageService
      .getItem$(LOCAL_STORAGE_KEYS.LOGIN)
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        this.userDetails = data;
      });

    this.socketService.connectMe();
    this.socketService.data_importing
      .pipe(takeUntil(this.destroy$))
      .subscribe((res: any) => {
        if (res.message === 'employee-imported') {
          this.toastr.success('Employees List Updated');
        } else if (res.message === 'existed-employee') {
          this.toastr.success('Exported Existed Employees List');
          window.open(environment.apiDomain + res.file_url);
        }
      });

    this.checkRoute();
    this.router.events
      .pipe(filter((e) => e instanceof NavigationEnd), takeUntil(this.destroy$))
      .subscribe(() => this.checkRoute());
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  checkRoute(): void {
    const url = this.router.url;
    if (url.includes('/home/products')) {
      this.activeTab = 'home';
    } else if (url.includes('/home/permissions')) {
      this.activeTab = 'settings';
      this.activeSettingsTab = 'permission';
    } else if (url.includes('/home/settings')) {
      this.activeTab = 'settings';
      this.activeSettingsTab = 'general';
    } else if (url.includes('/home/users')) {
      this.activeTab = 'masters';
      this.activemasterTab = 'employees';
    } else if (url.includes('/home/roles')) {
      this.activeTab = 'masters';
      this.activemasterTab = 'roles';
    } else if (url.includes('/home/department')) {
      this.activeTab = 'masters';
      this.activemasterTab = 'departments';
    } else if (url.includes('/home/company')) {
      this.activeTab = 'masters';
      this.activemasterTab = 'company';
    } else if (url.includes('/home/modules')) {
      this.activeTab = 'masters';
      this.activemasterTab = 'modules';
    } else if (url.includes('/home/workflow')) {
      this.activeTab = 'workflows';
    }
  }

  toggleSidebar(): void {
    this.modalService.open(NavBarComponent, {
      size: 'md',
      windowClass: 'modal-sac',
      centered: true,
      animation: true,
    });
  }

  // getInitials(name?: string): string {
  //   if (!name) return '';
  //   const parts = name.trim().split(' ');
  //   return ((parts[0]?.charAt(0) || '') + (parts[1]?.charAt(0) || '')).toUpperCase();
  // }
  getInitials(name?: string): string {
  if (!name) return '';
  return name.trim().charAt(0).toUpperCase();
}

  changePassword(): void {
    this.router.navigate(['/change-password'], {
      state: { allowChangePassword: true },
    });
    localStorage.setItem('allowChangePassword', 'true');
  }

  logout(): void {
    const cleanup = () => {
      this.localStorageService.clearAll();
      sessionStorage.clear();
      ['sid', 'user_id', 'full_name', 'system_user'].forEach(
        (n) => (document.cookie = `${n}=; Expires=Thu, 01 Jan 1970 00:00:00 GMT; Path=/;`)
      );
      this.router
        .navigateByUrl('/', { replaceUrl: true })
        .then((ok) => { if (!ok) window.location.href = '/'; })
        .catch(() => (window.location.href = '/'));
      localStorage.setItem('logout-event', Date.now().toString());
    };

    this.http.get(ApiUrls.logout).subscribe({ next: cleanup, error: cleanup });
  }

  onHotelSelect(selectionData: any): void {
    this.hospitalityService.setMarshaData(selectionData);
  }
}
